import { render, staticRenderFns } from "./vue-multiselect.vue?vue&type=template&id=5da6661c"
import script from "./vue-multiselect.vue?vue&type=script&lang=js"
export * from "./vue-multiselect.vue?vue&type=script&lang=js"
import style0 from "./vue-multiselect.vue?vue&type=style&index=0&id=5da6661c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports